import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:id`
    },
    getMinimalInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:id/minimal`
    },
    getCosignerApplicationForOriginatingApplicationId: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:originatingApplicationId/cosignerApplication`
    },
    getCosignerUserInfoForApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:originatingApplicationId/cosignerUserInfo`
    },
    getCosignerApplicationMapForApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:originatingApplicationId/cosignerApplicationMap`
    },
    canDeleteCosigner: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:originatingApplicationId/canDeleteCosigner`
    },
    getCosignerTrackingInfoForApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:originatingApplicationId/cosignerTrackingInfo`
    },
    getLeaseCosigners: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/leaseCosigners`
    },
    getApplicationFeePaymentDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/feePaymentDetails`
    },
    processApplicationFee: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/processFee`
    },
    createApplicantCreditCardPaymentMethod: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/creditCardPaymentMethod`
    },
    addCosignerContactInfoForApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/cosignerContactInfo`
    },
    sendCosignerApplicationEmail: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/sendCosignerApplicationEmail`
    },
    requestCosignerContactInfoForApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/requestCosignerContactInfo`
    },
    deleteCosignerContactInfoForApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/deleteCosignerContactInfo`
    },
    DeleteApplicationPayment: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applications/:applicationId/fee/:journalId`
    },
    ReverseApplicationPayment: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/fee/:journalId/reverse`
    },
    GetApplicationBgCheckScreeningInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/bgChecks/:bgCheckId`
    },
    GetBasicApplicantScreeningInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/basicApplicantScreening/:screeningRequestId`,
        isArray: true
    },
    GetApplicationBgChecks: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/bgChecks`
    },
    getScreeningsByApplicationId: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/screenings`
    },
    getScreeningReportStatusByRequestId: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditretriever/screenings/:requestId/reportStatus`
    },
    getAttachmentFileTags: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/attachment/tags?fileName=:fileName`
    },
    deleteApplicationAttachment: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applications/:applicationId/attachment?fileName=:fileName`
    },
    registerEditAcknowledgment: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/editAcknowledgment`
    },
    saveRentalHistoryVerificationRequestApplicantAuth: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/:applicationId/applicantRhvAuth`
    },
    getAutomatedTenantScreeningSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/automatedTenantScreeningSettings`
    }
};

export function ApplicationsApi() {
    return createActions(actions);
}
